'use client';

import React from 'react';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { Button } from '@depop/web-ui-kit/Button';
import { Modal } from '@depop/web-ui-kit/Modal';
import { useTranslations } from 'next-intl';

import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

const PADLOCK_IMAGE_SRC = `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/trustPage/padlock.png`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onUpdateUsernameClick?: () => void;
};

function Content({
  onUpdateUsernameClick,
}: {
  onUpdateUsernameClick?: () => void;
}) {
  const t = useTranslations('common');
  return (
    <div className={styles.container}>
      <img
        className={styles.padlock}
        src={PADLOCK_IMAGE_SRC}
        alt=""
        width={120}
        height={120}
      />
      <Heading variant="lg" className={styles.title}>
        {t('UsernameEmailSafetyModal.Title')}
      </Heading>
      <Body variant="sm-regular" className={styles.textBody}>
        {t('UsernameEmailSafetyModal.Body')}
      </Body>
      <ExtendedLink
        className={styles.cta}
        href="/settings/"
        onClick={onUpdateUsernameClick}
      >
        <Button as="span">{t('UsernameEmailSafetyModal.CtaText')}</Button>
      </ExtendedLink>
    </div>
  );
}

export function UsernameEmailSafetyModal({
  isOpen,
  onClose,
  onUpdateUsernameClick,
}: Props) {
  const t = useTranslations('common');
  return (
    <Modal
      content={() => <Content onUpdateUsernameClick={onUpdateUsernameClick} />}
      isOpen={isOpen}
      setOpen={() => onClose()}
      label={t('UsernameEmailSafetyModal.Title')}
      customOverrides={{ fullscreenAtSmallBreakpoint: true }}
    />
  );
}
